module.exports = __webpack_public_path__ + "img/norton.56c0268.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/norton.png
// module id = ./assets/img/norton.png
// module chunks = 2 3 4 5 6 7